import client from './client';
import { Order, OrderSheet, Product, Store, Tag, WaitlistEntry } from '../types';

const mapOrders = (orders: any[]): Order[] =>
  orders.map((order: any) => ({
    ...order,
    storeName: order.store?.name || 'Unknown Store',
    date: new Date(order.createdAt).toLocaleString('ko-KR'),
  }));

export interface CustomerOrderPageData {
  store: Store | null;
  products: Product[];
  activeOrderSheet: OrderSheet | null;
  tags: Tag[];
}

export interface CustomerOrderHistoryPageData {
  orders: Order[];
  waitlists: WaitlistEntry[];
  storeEditAvailability: Record<string, boolean>;
}

export const getCustomerOrderPage = async (
  storeId: string,
): Promise<CustomerOrderPageData> => {
  const response = await client.get('customer-pages/order-page', {
    params: { storeId },
  });
  return response.data;
};

export const getCustomerOrderHistoryPage = async (params?: {
  name?: string;
  phone?: string;
}): Promise<CustomerOrderHistoryPageData> => {
  const response = await client.get('customer-pages/history', {
    params,
  });
  return {
    ...response.data,
    orders: mapOrders(response.data.orders || []),
    waitlists: response.data.waitlists || [],
  };
};
